import { topicInitials } from '@/constants/topics'

// A topic's picture in a circle (2026-10-16: every kind of topic, not just
// people). The pipeline picks it (tasks/entities.picture) and says what it
// is: a photo fills the circle; a logo, seal or flag sits whole inside it on
// white, so a wordmark or a flag isn't cropped. No picture: initials.
export default function TopicAvatar({ topic, size = 'h-8 w-8 text-[11px]' }) {
  const frame = `${size} shrink-0 rounded-full border border-border`
  if (!topic.image) {
    return (
      <span
        aria-hidden="true"
        className={`${frame} inline-flex items-center justify-center bg-muted font-sans font-semibold text-muted-foreground`}
      >
        {topicInitials(topic.name)}
      </span>
    )
  }
  // No kind: a row from before kinds were recorded, when only people had
  // images.
  if (!topic.imageKind || topic.imageKind === 'photo') {
    return (
      // Hotlinked from Wikimedia (credited on the topic page).
      // eslint-disable-next-line @next/next/no-img-element
      <img src={topic.image} alt="" className={`${frame} object-cover`} />
    )
  }
  return (
    <span
      aria-hidden="true"
      className={`${frame} inline-flex items-center justify-center overflow-hidden bg-white`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={topic.image}
        alt=""
        className={`object-contain ${
          // A wordmark is wide: give it the circle's width.
          topic.imageKind === 'logo' ? 'h-[86%] w-[86%]' : 'h-[68%] w-[68%]'
        }`}
      />
    </span>
  )
}
